import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useProducts = (page, term = null) => useQuery({ queryKey: [`cart`, page, term], queryFn: async () => {
    const callback = await API.get(`/store/products?page=${page}${term ? `&term=${term}` : ''}`)
    return callback?.data
}, staleTime: 1000 * 60 * 5, gcTime: 1000 * 60 * 15 })

export default useProducts